import React, { Component } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Auth from '../../Auth/Auth';
import result from '../../images/result-page.jpg';
import search from '../../images/search-page.jpg';
import './UserPreferences.scss';

const auth = new Auth();

export default class UserPreferences extends Component {
    constructor(props) {
        super(props);

        this.state = {
            smartTabs: [{ "name": "Namespace Search", "value": "namespace" },      
            { "name": "On Call Schedule", "value": "onCall" },
            { "name": "Suggested Links and Items", "value": "Suggested" },
            { "name": "Search Subscriptions", "value": "SearchSubs" },
            { "name": "Announcements", "value": "Notifications" }],
            TimeZones: [],
            Id: "",
            homeScreen: "",
            selectedSmartPanel: "Choose...",
            selectedTimeZone: "Choose...",
            selectedTheme: "Choose...",
            hideFrench: false,
            fetchTips: true
        };
    }

    async componentDidMount() {

        fetch(`${process.env.PUBLIC_URL}/timezone.json`)
            .then(response => {
                if (response.status !== 200) {
                    let payload = [{
                        status: response.status,
                        rawmsg: response.statusText,
                        cleanmsg: response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp: Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                    };
                }
                return response.json();
            })
            .then(data => {
                this.setState({
                    TimeZones: data
                });
            }).catch((error) => {
                window.apiError(error);
            });

        if (localStorage.getItem("userPreferences") === null) {
            let accessToken = await auth.getToken();
            fetch('/api/getUserPreferences', {
                method: "GET",
                headers: {
                    'Authorization': "Bearer " + accessToken,
                    withCredentials: true,
                    crossDomain: true,
                }
            }).then(response => {
                if (response.status !== 200) {
                    let payload = [{
                        status: response.status,
                        rawmsg: response.statusText,
                        cleanmsg: response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp: Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                    };
                }
                return response.json();
            })
                .then(data => {
                    if (data[0]) {
                        let data = data[0];
                        this.setState({
                            Id: data.Id,
                            homeScreen: data.HomeScreen,
                            selectedSmartPanel: data.SmartPanelTab,
                            selectedTimeZone: data.TimeZone,
                            selectedTheme: data.Theme,
                            hideFrench: data.HideFrench,
                            fetchTips: data.FetchTips
                        });
                        localStorage.setItem("userPreferences", JSON.stringify(data[0]));
                    }
                }).catch((error) => {
                    console.error('Error:', error);
                });
        } else {
            let preferences = JSON.parse(localStorage.getItem("userPreferences"));
            this.setState({
                Id: preferences.Id,
                homeScreen: preferences.HomeScreen,
                selectedSmartPanel: preferences.SmartPanelTab,
                selectedTimeZone: preferences.TimeZone,
                selectedTheme: preferences.Theme,
                hideFrench: preferences.HideFrench,
                fetchTips: preferences.FetchTips
            });
        }

    }

    async savePreferences() {
        let preferences = {
            Id: this.state.Id,
            HomeScreen: this.state.homeScreen,
            SmartPanelTab: this.state.selectedSmartPanel,
            TimeZone: this.state.selectedTimeZone,
            Theme: this.state.selectedTheme,
            HideFrench: this.state.hideFrench,
            FetchTips: this.state.fetchTips,
        };

        let accessToken = await auth.getToken();
        fetch(`/api/addUserPreferences`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': "Bearer " + accessToken,
                withCredentials: true,
                crossDomain: true,
            },
            body: JSON.stringify(preferences)
        }).then(response => {
            if (response.status !== 200) {
                let payload = [{
                    status: response.status,
                    rawmsg: response.statusText,
                    cleanmsg: response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp: Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return response.json();
        })
            .then(success => {
                let userPreferenceLocal = JSON.parse(localStorage.getItem("userPreferences"));
                if (userPreferenceLocal !== null) {
                    success.FetchProTourComplete = userPreferenceLocal.FetchProTourComplete;
                }
                success.PreferenceStamp = new Date(new Date().toLocaleDateString()).valueOf();

                localStorage.setItem("userPreferences", JSON.stringify(success));
                this.props.closeModal();
                toast(`Refresh the page to see your updated preferences`, {
                    position: "top-right",
                    hideProgressBar: false,
                    closeOnClick: true,
                });
                sessionStorage.removeItem("showUserPreferenceModal");
            }).catch((error) => {
                window.apiError(error);
            });
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    completed() {
        if (this.state.homeScreen !== "" && this.state.selectedSmartPanel !== "Choose..." && this.state.selectedTimeZone !== "Choose..." && this.state.selectedTheme !== "Choose...") {
            return false;
        }

        return true;
    }

    render() {
        return (
            <div id="user-preferences">
                <Row>
                    <Col lg={{ span: 12 }}>
                        <h5>User Preferences</h5>
                        <p className="mb-0 text-muted" style={{ marginTop: "-10px" }}><small>Updated on refresh</small></p>
                    </Col>
                    <Col lg={{ span: 12 }}>
                        <Row>
                            <Col lg={{ span: 4 }}>
                                <Form.Group>
                                    <Form.Label as="legend">
                                        Home <span style={{ color: "red" }}>*</span>
                                    </Form.Label>
                                    <Form.Check
                                        type="radio"
                                        label="Main Search"
                                        id={`main-search-check`}
                                        name="homeScreen"
                                        checked={this.state.homeScreen === "Main Search"}
                                        onChange={() => this.setState({ homeScreen: "Main Search" })}
                                    />
                                    <Form.Check
                                        type="radio"
                                        label="Result Page"
                                        id={`result-page-check`}
                                        name="homeScreen"
                                        checked={this.state.homeScreen === "Result Page"}
                                        onChange={() => this.setState({ homeScreen: "Result Page" })}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={{ span: 8 }}>
                                {this.state.homeScreen === "Main Search" ?
                                    <img src={search} style={{ width: "80%" }} />
                                    :
                                    <img src={result} style={{ width: "80%" }} />
                                }
                            </Col>
                        </Row>

                        <Form.Group controlId="formGridState">
                            <Form.Label>Smart Panel Tab <span style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control as="select" name="selectedSmartPanel" onChange={(e) => this.handleChange(e)} value={this.state.selectedSmartPanel}>
                                <option disabled>Choose...</option>
                                {this.state.smartTabs.map((items, index) =>
                                    <option key={index} value={items.value}>{items.name}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="formGridState">
                            <Form.Label>Time Zone <span style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control as="select" name="selectedTimeZone" onChange={(e) => this.handleChange(e)} value={this.state.selectedTimeZone}>
                                <option disabled>Choose...</option>

                                {this.state.TimeZones.map((items, index) =>
                                    <option key={index} value={items.value}>{items.text}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Theme <span style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control as="select" name="selectedTheme" onChange={(e) => this.handleChange(e)} value={this.state.selectedTheme}>
                                <option disabled>Choose...</option>
                                <option>Light</option>
                                <option>Dark</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group className="m-0">
                            <Form.Check type="checkbox" id={`hideFrench-check`} className="ml-0" label="Don't show French Ticket/KB" checked={this.state.hideFrench} onChange={() => this.setState({ hideFrench: !this.state.hideFrench })} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check type="switch" id={`fetch-tip-check`} className="pl-3 form-check " label="Receive Fetch Tips" checked={this.state.fetchTips} onChange={() => this.setState({ fetchTips: !this.state.fetchTips })} />
                        </Form.Group>
                    </Col>
                    <Col lg={{ span: 12 }} className="text-right">
                        <Button variant="outline-secondary" size="sm" onClick={() => this.props.closeModal()}>Cancel</Button>
                        <Button variant="primary"
                            size="sm"
                            onClick={() => this.savePreferences()}
                            disabled={this.completed()}>Save</Button>
                    </Col>
                </Row>
            </div>
        );
    }
}